import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useHappytalk from "../hooks/useHappytalk";
import Support from "./Support";
import "./Footer.css";

export default function Footer() {
  const { t } = useTranslation();
  const openContact = useHappytalk();
  // 로그인·마이페이지는 본문에 후원 칸이 따로 있어 맨 아래 칸은 숨긴다
  const { pathname } = useLocation();
  const path = pathname.replace(/\/+$/, "") || "/"; // "/guide/" 처럼 끝 슬래시로 오는 경우
  // 관리자 화면에는 후원 칸을 띄우지 않는다
  const pageHasSupport = path === "/login" || path.startsWith("/mypage") || path.startsWith("/admin");
  // 후원 칸 폭을 그 페이지 본문 폭에 맞춘다 (2026-10-19 김현비). 목록에 없으면 기본 1116px.
  const supportWidth =
    ["/guide", "/service-info", "/privacy", "/terms"].includes(path) ? 1000
    : path === "/printing-faq" ? 936
    // 주문 페이지는 견적 화면(print)과 같은 980px (v0.20.2) — 후원 칸도 같은 폭으로 (2026-10-21 김현비)
    : path.startsWith("/order") ? 980
    : ["/register", "/forgot-password", "/update-password"].includes(path) ? 900
    : 1116;

  return (
    <>
      {!pageHasSupport && (
        <div className="support-footer-band"><div className="support-footer-wrap" style={{ maxWidth: supportWidth + 64 }}><Support /></div></div>
      )}
      <footer className="footer">
        <div className="footer-inner">
          <div className="footer-left">
            <div className="footer-business">
              <p>(주)쓰리디메이커즈 | 대표 : 최정진 | 세종특별자치시 연서면 월성로 30, 101호, 201호</p>
              <p>사업자등록번호 : 360-86-00740 | 통신판매업신고 : 2017-세종조치원-0050호 | TEL : 044-864-8637 | 3d@makerz.co.kr</p>
            </div>
          </div>
          <div className="footer-right">
            <div className="footer-links">
              <Link to="/privacy">{t("privacy_policy")}</Link>
              <span className="divider">|</span>
              <Link to="/terms">{t("terms_of_service")}</Link>
              <span className="divider">|</span>
              <Link to="/service-info">{t("service_guide")}</Link>
              <span className="divider">|</span>
              <button className="footer-contact-btn" onClick={openContact}>
                문의하기
              </button>
            </div>
            <span className="footer-copy">© 2026 CookiStory</span>
          </div>
        </div>
      </footer>
    </>
  );
}
